import { jsx as _jsx } from "react/jsx-runtime";
import { edgeTypeMatrix } from '@iotv/datamodel';
import { TreeItem2 as TreeItem } from '@mui/x-tree-view';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useContext } from 'react';
import { AppMainViewContext } from '../../../../ContextProviders/AppContextProvider';
import { isAdminRole } from '../../../../helpers/access';
import { ObjectTree } from '../../../../v2/components/generic/ObjectTree';
import { ContextMenu } from '../../ContextMenuV2/ContextMenu';
import { CustFolderClickWrapper } from '../../clickWrappers/helpers';
import { customerProgrammeSetsTreeDef } from '../ProgrameSetsAndProgrammes';
dayjs.extend(utc);
export const SequentialProgrammes = ({ applicationData, contextCustomer, transactionFunctions, userFunctions, user, roleArbitrationInstance }) => {
    const [{ userSelectedGroup }] = useContext(AppMainViewContext);
    const sequentialProgrammesLabel = isAdminRole(userSelectedGroup)
        ? contextCustomer && (_jsx(ContextMenu, { label: "Sequential Programmes", hideDelete: true, popUpElement: null, contextObject: contextCustomer, edgeTypeIdFilter: [edgeTypeMatrix.Customer.EntityProgrammeSet.customer_has_entity_programme_set.edgeTypeId], ascendentAccessor: { ascendentAccessor: null, contextObject: contextCustomer } }))
        : 'Sequential Programmes';
    return (contextCustomer && (_jsx(TreeItem, { itemId: "ProgrammeSets", label: sequentialProgrammesLabel, children: _jsx(ObjectTree, { nodeEdgeMapper: applicationData,
            queryPaths: [customerProgrammeSetsTreeDef],
            contextObjects: [contextCustomer],
            transactionFunctions,
            onTypeFolderClickWrapper: CustFolderClickWrapper,
            hideTopStep: true }, `customerProgrammeSets`) }, 'ProgrammeSets')));
};
